export enum FormStage {
  Personal,
  Account,
}
